<template>
  <div>
    <h2 class="mb-4">Materie disponibili per ripetizione</h2>
    <div class="text-end me-4 mb-2">
      <button class="btn btn-danger btn-sm d-inline" @click="$emit('tornaIndietro')">Indietro</button>
    </div>

    <!-- Subject selection -->
    <SubjectList
      v-if="!materiaSelezionata"
      :items="materie"
      @select="selezionaMateria"
    />

    <!-- Show recommendations after subject selection -->
    <TutorRecommendations
      v-if="materiaSelezionata && showRecommendations && !showAllTutors && !selectedTutor"
      :student-id="currentUser.id"
      :subject-name="materiaSelezionata.nome"
      @back="backToSubjectSelection"
      @show-all-tutors="handleShowAllTutors"
      @view-tutor-details="handleViewTutorDetails"
      @view-profile="handleViewProfile"
      @book-slot="handleQuickBook"
    />

    <!-- Show all tutors availability (original behavior) -->
    <DisponibilitaMateria
      v-if="materiaSelezionata && showAllTutors && !selectedTutor"
      :materia="materiaSelezionata"
      :currentUser="currentUser"
    >
      <template #header>
        <button class="btn btn-outline-primary btn-sm mb-3" @click="backToRecommendations">
          <i class="fas fa-arrow-left me-1"></i>
          Torna ai tutor raccomandati
        </button>
      </template>
    </DisponibilitaMateria>

    <!-- Show specific tutor details -->
    <DisponibilitaMateria
      v-if="selectedTutor"
      :materia="materiaSelezionata"
      :currentUser="currentUser"
      :specific-tutor-id="selectedTutor.tutorId"
      :specific-tutor-name="selectedTutor.tutorName"
    >
      <template #header>
        <button class="btn btn-outline-primary btn-sm mb-3" @click="backToRecommendations">
          <i class="fas fa-arrow-left me-1"></i>
          Torna ai tutor raccomandati
        </button>
      </template>
    </DisponibilitaMateria>

    <!-- User Profile Modal -->
    <div v-if="showProfileModal" class="modal fade show d-block" tabindex="-1" style="background-color: rgba(0,0,0,0.5);">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Profilo Tutor</h5>
            <button type="button" class="btn-close" @click="closeProfileModal"></button>
          </div>
          <div class="modal-body">
            <UserProfile
              :userId="selectedProfileId"
              :is-own-profile="false"
              :student="false"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import DisponibilitaMateria from "@/components/DisponibilitaMateria.vue";
import SubjectList from "@/components/SubjectList.vue";
import TutorRecommendations from "@/components/TutorRecommendations.vue";
import UserProfile from "@/components/UserProfile.vue";
import config from "@/utils/config";

export default {
  components: {
    DisponibilitaMateria,
    SubjectList,
    TutorRecommendations,
    UserProfile
  },
  props: { currentUser: Object },
  data() {
    return {
      materie: [],
      materiaSelezionata: null,
      showRecommendations: true,
      showAllTutors: false,
      selectedTutor: null,
      showProfileModal: false,
      selectedProfileId: null
    };
  },

  mounted() {
    this.caricaMaterie();
  },

  methods: {
    caricaMaterie(){
      axios.get(config.baseUrl + "/materia").then(response => {
        this.materie = response.data;
      });
    },

    selezionaMateria(materia) {
      this.materiaSelezionata = materia;
      this.showRecommendations = true;
      this.showAllTutors = false;
      this.selectedTutor = null;
    },

    backToSubjectSelection() {
      this.materiaSelezionata = null;
      this.showRecommendations = true;
      this.showAllTutors = false;
      this.selectedTutor = null;
    },

    handleShowAllTutors() {
      this.showRecommendations = false;
      this.showAllTutors = true;
      this.selectedTutor = null;
    },

    backToRecommendations() {
      this.showRecommendations = true;
      this.showAllTutors = false;
      this.selectedTutor = null;
    },

    handleViewTutorDetails(tutorData) {
      this.selectedTutor = tutorData;
      this.showRecommendations = false;
      this.showAllTutors = false;
    },

    handleViewProfile(tutorId) {
      this.selectedProfileId = tutorId;
      this.showProfileModal = true;
    },

    closeProfileModal() {
      this.showProfileModal = false;
      this.selectedProfileId = null;
    },

    handleQuickBook({ tutor }) {
      // Quick book from time slot in recommendation
      // This will navigate to the specific tutor's availability
      this.handleViewTutorDetails({
        tutorId: tutor.tutorId,
        tutorName: tutor.tutorName,
        subject: this.materiaSelezionata.nome
      });
    }
  }
};
</script>

<style scoped>
.grid-container, .grid-item, .grid-item:hover { display: none; } /* Hide old styles */
</style>
